module.exports = __webpack_public_path__ + "img/Floor002650_logo.caccce12.png";